<template>
  <header
    :class="[
      'header',
      { 'header--home': page === 'Home' },
      { 'header--hidden': !showNavbar },
      { 'header--black': topBlack },
    ]"
  >
    <div class="limit-grid">
      <div class="header__wrapper">
        <div class="header__logo">
          <router-link :to="{ name: 'Home' }">
            <img
              src="@/assets/cartao+sport.png"
              alt="logo cartão de todos Sport"
              class="header__logo--cdt"
            />
          </router-link>
        </div>
        <a
          href="https://torcedores.cartaodetodos.com.br/dados-pessoais/?idserv=27"
          target="_blank"
          class="header__button"
          @click="handleCTAClick"
          >Solicite seu Cartão</a
        >
      </div>
    </div>
  </header>
</template>

<script>
import { handleCTAClick } from "@/services/gtm";

export default {
  data() {
    return {
      page: null,
      lastScrollPosition: 0,
      showNavbar: true,
      topBlack: false,
    };
  },
  methods: {
    handleCTAClick,
    onScroll() {
      if (window.pageYOffset < 0) {
        return;
      }
      if (Math.abs(window.pageYOffset - this.lastScrollPosition) < 130) {
        return;
      }

      if (window.pageYOffset > 150 && this.$route.name === "Home") {
        this.topBlack = true;
      } else {
        this.topBlack = false;
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition;
      this.lastScrollPosition = window.pageYOffset;
    },
  },
  mounted() {
    this.lastScrollPosition = window.pageYOffset;
    window.addEventListener("scroll", this.onScroll);
  },
  created() {
    this.page = this.$route.name;
  },
};
</script>

<style lang="scss">
.header {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0px;
  width: 100%;
  justify-content: center;
  background: $color-black;
  transform: translate3d(0, 0, 0);
  transition: 0.3s ease-in-out;
  padding: 20px 0;
  @include media(">=tablet") {
    &--hidden {
      transform: translate3d(0, -100%, 0);
    }
  }
  &--home {
    background: transparent;
  }
  &--black {
    background: $color-black;
  }
  &__wrapper {
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    align-items: center;
    gap: 16px;
    @include media(">=tablet") {
      grid-template-columns: auto max-content;
      justify-items: initial;
    }
  }
  &__logo {
    a {
      display: block;
      border: none !important;
      padding: 0 !important;
    }
    &--cdt {
      display: block;
      width: 100%;
      max-width: 185px;
      height: 40px;
      @include media(">=tablet") {
        max-width: 200px;
        height: 45px;
      }
    }
  }
  &__button {
    display: none;
    border-radius: 16px;
    background: $color-secondary;
    color: #000;
    font-family: "Lato", sans-serif;
    font-weight: 700;
    line-height: normal;
    text-decoration: none;
    transition: 0.3s ease-in-out;
    text-align: center;
    &:hover {
      background: $color-red;
    }
    @include media(">=tablet") {
      display: inline-block;
      padding: 13px 32px;
      font-size: 16px;
    }
  }
}
</style>
